import { ReactNode } from "react";
import styled from "styled-components/native";

export const StyledNarrowMain = styled.View`
	display: flex;
	padding: 6.5rem 8rem 1.5rem 8rem;
	align-items: flex-start;
	gap: 1rem;
	flex: 1 0 0;
	align-self: stretch;
	flex-direction: row;
`;

interface Props {
	children: ReactNode;
}

const NarrowCreateAccountWrapper: React.FC<Props> = ({ children }) => {
	return (
		// @ts-ignores
		<StyledNarrowMain>{children}</StyledNarrowMain>
	);
};

export default NarrowCreateAccountWrapper;
